import { Button, FormFileInput, LoadingIndicator, useModal } from '../../../../../../components'
import { ButtonType, showAlert, showError } from '../../../../../../../_metronic/helpers'
import { uploadNota } from '../../core/_requests'
import { useFormik } from 'formik'
import { uploadNotaSchema } from './validation/uploadNotaSchema'

type IProps = {
  idNota: number
}

export const UploadNotaModal = ({ idNota }: IProps) => {
  const { closeModal } = useModal()

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      pdf: undefined as File | undefined,
      xml: undefined as File | undefined,
    },
    validationSchema: uploadNotaSchema,
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true)
      try {
        await uploadNota(idNota, values.pdf as File, values.xml as File)
        showAlert({ title: 'Sucesso', text: 'Nota enviada com sucesso!', icon: 'success' })
        closeModal()
      } catch (error) {
        showError(error)
      } finally {
        setSubmitting(false)
      }
    },
  })

  return (
    <form onSubmit={formik.handleSubmit} noValidate>
      <div className='row'>
        <div className='col-md-6 mb-3'>
          <FormFileInput
            formik={formik}
            name='pdf'
            accept='application/pdf'
            label='PDF da nota'
            isDisabled={formik.isSubmitting}
          />
        </div>
        <div className='col-md-6 mb-3'>
          <FormFileInput
            formik={formik}
            name='xml'
            accept='.xml'
            label='XML da nota'
            isDisabled={formik.isSubmitting}
          />
        </div>
      </div>

      <div className='d-flex justify-content-center mt-5'>
        <Button className='btn-secondary me-2' onClick={closeModal}>
          Cancelar
        </Button>
        <Button type={ButtonType.Submit} className='btn-primary' disabled={formik.isSubmitting}>
          {formik.isSubmitting ? <LoadingIndicator /> : 'Enviar'}
        </Button>
      </div>
    </form>
  )
}
